import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Work from './pages/Work';
import CaseDetail from './pages/CaseDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Navigation from './components/Navigation';
import CustomCursor from './components/CustomCursor';
import Loader from './components/Loader';

const PageTransitionWrapper = () => {
  const location = useLocation();
  const [phase, setPhase] = useState('idle'); // idle | in | out
  const [displayLocation, setDisplayLocation] = useState(location);

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setPhase('in');
      const t1 = setTimeout(() => {
        setDisplayLocation(location);
        window.scrollTo(0, 0);
        setPhase('out');
      }, 600);
      const t2 = setTimeout(() => setPhase('idle'), 1300);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    }
  }, [location, displayLocation]);

  return (
    <>
      <div className={`page-curtain ${phase === 'in' ? 'in' : phase === 'out' ? 'out' : ''}`} />
      <Routes location={displayLocation}>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/work/:slug" element={<CaseDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
};

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 1700);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App film-grain">
      <CustomCursor />
      <Loader done={loaded} />
      <BrowserRouter>
        <Navigation />
        <PageTransitionWrapper />
      </BrowserRouter>
    </div>
  );
}

export default App;
